<template>
    <div class="bonusomat-onboarding-page__device" :class="codeName">
        <div class="bonusomat-onboarding-page__screen-scroll">
            <div class="bonusomat-onboarding-page__screen">
                <WebpImage
                    class="bonusomat-onboarding-page__image-wrapper"
                    css-class="bonusomat-onboarding-page__image"
                    :src="image"
                    :alt="title"
                    :get2x="true"
                />
                <div class="bonusomat-onboarding-page__text">
                    <h3 class="bonusomat-onboarding-page__title" v-html="title"></h3>
                    <div class="bonusomat-onboarding-page__description" v-html="description"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";

defineProps<{
    codeName: string;
    image: string;
    title: string;
    description: string;
}>();
</script>
